/**
 * Common Catalog Fields to used in master data, inventory and pricing
 */
const commonCatalogFields = {
  ITEM_NUMBER: {
    key: 'itemNo',
    label: 'Item No',
  },
  BARCODE: {
    key: 'barcode',
    label: 'Barcode',
  },
  DEPARTMENT: {
    key: 'dept',
    label: 'Department',
  },
  SECTION: {
    key: 'section',
    label: 'Section',
  },
  FAMILY: {
    key: 'family',
    label: 'Family',
  },
  SUB_FAMILY: {
    key: 'subFamily',
    label: 'Sub Family',
  },
  ERP_ITEM_DESC: {
    key: 'description',
    label: 'ERP Item Description',
  },
  ERP_UOM: {
    key: 'uom',
    label: 'ERP UOM',
  },
  QTY_PER_UOM: {
    key: 'qtyPerUom',
    label: 'QTY Per UOM',
  },
  ERP_PACK_INFO: {
    key: 'uomPackagingInfo',
    label: 'ERP Pack Info',
  },
  ERP_BRAND: {
    key: 'erpBrand',
    label: 'ERP Brand',
  },
  ONLINE_DESC: {
    key: 'onlineDesc',
    label: 'Online Description',
  },
  ONLINE_PACK_INFO: {
    key: 'onlinePackInfo',
    label: 'Online Pack Info',
  },
}

/**
 * Master Data Form Fields
 */
const MASTER_DATA_FORM_FIELDS = {
  ...commonCatalogFields,
  ERP_MARKETING_CODE: {
    key: 'erpMarketingCode',
    label: 'ERP Marketing Code',
  },
  VAT_CLASS: {
    key: 'vatClass',
    label: 'VAT Class',
  },
  VAT_PERCENTAGE: {
    key: 'vatPercentage',
    label: 'VAT Percentage',
  },
  ACTIVE_ONLINE: {
    key: 'activeOnline',
    label: 'Active Online',
  },
  HIDE_AGGREGATORS: {
    key: 'hideAggregators',
    label: 'Hide Aggregators',
  },
}

/**
 * Pricing Form Fields
 */
const PRICING_FORM_FIELDS = {
  ...commonCatalogFields,
  STORE_NAME: {
    key: 'storeName',
    label: 'Store Name',
  },
  ERP_PRICE: {
    key: 'erpPrice',
    label: 'ERP Price',
  },
  STORE_ID: {
    key: 'storeId',
    label: 'Store ID',
  },
  SPECIAL_PRICE: {
    key: 'specialPrice',
    label: 'Special Price',
  },
  SPECIAL_PRICE_START_DATE: {
    key: 'specialPriceStartDate',
    label: 'Special Price Start Date',
  },
  SPECIAL_PRICE_END_DATE: {
    key: 'specialPriceEndDate',
    label: 'Special Price End Date',
  },
  PROMO: {
    key: 'promo',
    label: 'Promo',
  },
  PROMO_START_DATE: {
    key: 'promoStartDate',
    label: 'Promo Start Date',
  },
  PROMO_END_DATE: {
    key: 'promoEndDate',
    label: 'Promo End Date',
  },
  AGGREGATOR_ID: {
    key: 'aggregator',
    label: 'Aggregator ID',
  },
  ONLINE_PRICE: {
    key: 'onlinePrice',
    label: 'Online Price',
  },
  LAST_PRICE_UPDATE: {
    key: 'updatedAt',
    label: 'Last Price Update',
  },
  SLASH_PRICE: {
    key: 'slashPrice',
    label: 'Slash Price',
  },
  SLASH_PRICE_START_DATE: {
    key: 'slashPriceStartDate',
    label: 'Slash Price Start Date',
  },
  SLASH_PRICE_END_DATE: {
    key: 'slashPriceEndDate',
    label: 'Slash Price End Date',
  },
  BLOCK_SALE_ON_POS: {
    key: 'blockSaleOnPos',
    label: 'Block Sale On POS',
  },
}

/**
 * Inventory Form Fields
 */
const INVENTORY_FORM_FIELDS = {
  ...commonCatalogFields,
  STORE_NAME: {
    key: 'storeName',
    label: 'Store Name',
  },
  STORE_ID: {
    key: 'storeId',
    label: 'Store ID',
  },
  LAST_QTY_UPDATE: {
    key: 'lastUpdatedOnErp',
    label: 'Last QTY Update',
  },
  ERP_QTY: {
    key: 'erpQty',
    label: 'ERP QTY',
  },
  OOS_THRESHOLD: {
    key: 'oosThreshold',
    label: 'OOS Threshold',
  },
  SELLABLE_QTY: {
    key: 'sellableQty',
    label: 'Sellable QTY',
  },
  ON_STOCK: {
    key: 'isOnStock',
    label: 'In Stock',
  },
  USE_GLOBAL_THRESHOLD: {
    key: 'useGlobalThreshold',
    label: 'Use Global Threshold',
  },
  IGNORE_UPDATE_TO_MAGENTO: {
    key: 'ignoreUpdateToMagento',
    label: 'Ignore Update To Magento',
  },
  BLOCK_ERP_INVENTORY: {
    key: 'blockErpInventory',
    label: 'Block Erp Inventory',
  },
} as const

export { INVENTORY_FORM_FIELDS, PRICING_FORM_FIELDS, MASTER_DATA_FORM_FIELDS }
